import React from 'react'
import CenteredLoadingSpinner from '../../common/CenteredLoadingSpinner'

export default function TimelineTabSkeleton(): JSX.Element {
  return <CenteredLoadingSpinner />
}
